import {
    AGENDA_EVENT_GET,
    ATTENDEE_EVENT_GET,
    ATTENDEES_EVENT_GET,
    ATTENDEES_EVENT_CLEAR,
    EVENT_GET,
    EVENT_GET_ERROR,
    EVENT_LOADING_STATUS,
    EVENTS_FETCH,
    EVENTS_FETCH_CATEGORIES,
    GET_ACTION_LINKS,
    PARTNERS_EVENT_GET,
    REMOVE_ATTENDEES_EVENT,
    SESSION_EVENT_GET,
    SESSION_EVENT_CLEAR,
    GET_ACTION_FILES,
    SESSION_EVENT_QUESTIONS_GET,
    SESSION_EVENT_QUESTIONS_CLEAR,
    EVENTS_CLEAR,
    EVENT_LOADING_CATEGORIES_STATUS,
    EVENT_GET_TRACKS,
    EVENT_TRACKS_LOADING_STATUS,
    EVENT_CLEAR_TRACKS,
    EVENT_MY_AGENDA_LOADING_STATUS,
    EVENT_AGENDA_UPDATE_ITEM,
    EVENT_POLLS_LOADING_STATUS,
    UPDATE_EVENT_POLLS,
    EVENT_SPEAKERS_GET,
    EVENT_SPEAKERS_CLEAR,
    SESSION_EVENT_DELETE_LOADING,
    EVENT_RATINGS_LOADING_STATUS,
    UPDATE_EVENT_RATINGS,
    UPDATE_SESSION_RATINGS,
    EVENT_GET_EXHIBITOR,
    EVENT_GET_EXHIBITOR_ERROR,
    SET_FOLLOW_STATUS,
    SET_FOLLOW_NOTE,
    GET_BOOT_STAFF_LIST,
    BOOT_STAFF_LOADING_STATUS,
    EVENTS_FETCH_ERROR,
    DELETE_FOLLOW_NOTE,
    POST_EVENT_SESSIONS_REGISTER,
    POST_EVENT_SESSIONS_REGISTER_LOADING,
    DELETE_EVENTS_SESSIONS_REGISTER,
    EVENT_CLEAR_EXHIBITOR,
    EVENT_PRIVATE_LOADING,
    GET_SUB_SESSIONS,
    GET_SUB_SESSIONS_LOADING,
    GET_SUB_SESSIONS_ERROR,
    GET_SESSIONS_SPEAKERS_LIST,
    GET_SESSIONS_SPEAKERS_LIST_LOADING,
    GET_SESSIONS_SPEAKERS_LIST_ERROR,
    GET_SURVEY,
    GET_SURVEY_LOADING,
    GET_SURVEY_ERROR,
    POST_SURVEY_CLASSIC_LOADING,
    POST_SURVEY_CLASSIC_ERROR,
    GET_PARTNER_FILES,
    GET_PARTNER_FILES_LOADING,
    GET_PARTNER_FILES_ERROR,
    GET_GIVEAWAYS,
    GET_GIVEAWAYS_LOADING,
    GET_GIVEAWAYS_ERROR,
    GET_GIVEAWAYS_ERROR_CLEAR,
    GET_DATE_LIST_EVENTS,
    GET_DATE_LIST_LOADING,
    GET_DATE_LIST_ERROR,
    GET_SPEAKER_FILTER_LIST,
    GET_SPEAKER_FILTER_LOADING,
    GET_SPEAKER_FILTER_LIST_ERROR,
    GET_SPEAKER_FILTER_CLEAR
} from '@/store/event/types'
import { removeAgendaItem, updateAgendaItem } from '../../utils/helpers'

const initialState = {
	loading: false,
	surveyLoading: false,
	surveyPostError: null,
	deleteQuestionLoading: false,
	loadingCategories: false,
	event: {},
	survey: {},
	surveyError: null,
	agenda: [],
	subSessions: [],
	subSessionsLoading: false,
	subSessionsError: null,
	errors: [],
	events: [],
	session: null,
	sessionQuestions: null,
	partners: [],
	attendees: [],
	attendee: null,
	categories: [],
	categoriesMeta: null,
	actionFiles: [],
	actionLinks: [],
	speakers: [],
	speakersMeta: null,
	exhibitor: null,
	exhibitorError: null,
	privateLoading: false,
	sessionAllSpeakers: [],
	sessionAllSpeakersError: null,
	sessionAllSpeakersLoading: false,

    dateListEvent: [],
    dateListLoading: false,
    dateListError: null,

	tracks: [],
	tracksMeta: null,
	loadingTracks: false,

	actionLinksMeta: null,
	actionFilesMeta: null,
	sessionQuestionsMeta: null,

	pageCount: {
		events: 0,
		agendas: 0,
		partners: 0,
		attendees: 0,
		boothStaff: 0,
		subSessions: 0,
		sessionsSpeakers: 0,
        partnerFiles: 0,
        giveawaysCount: 0,
	},
	totalCount: {
		attendees: 0,
		boothStaff: 0,
	},
	myAgendaIsLoading: false,
	myAgendaIdIsLoading: null,
	pollsLoading: false,
	ratingsLoading: false,
	exhibitorPartner: {
		follow_status: null,
		follow_note: '',
	},
	boothStaffList: [],
	boothStaffLoading: false,
	sessionRegister: {
		session_id: null,
		user_id: null,
		description: null,
	},
	sessionRegisterLoading: false,
	deleteSessionRegister: {
		session_id: null,
		user_id: null,
		description: null,
	},
    partnerFiles: [],
    partnerFilesLoading: false,
    partnerFilesError: null,
    giveaways: [],
    giveawaysLoading: false,
    giveawaysError: null,
    speakerFilter: [],
    speakerFilterMeta: null,
    isSpeakerFilterLoading: false,
    speakerFilterError: null,
}

export const state = { ...initialState }

export default {
    [GET_SPEAKER_FILTER_CLEAR]:(state) => {
        state.speakerFilter = []
    },
    [GET_SPEAKER_FILTER_LIST_ERROR]:(state, payload) => {
        state.errors = payload
    },
    [GET_SPEAKER_FILTER_LOADING]:(state,payload)=>{
        state.isSpeakerFilterLoading = payload
    },
    [GET_SPEAKER_FILTER_LIST]:(state, payload)=>{
        const { data, pageCount, perPage, totalCount, currentPage } = payload
        state.speakerFilter = [...state.speakerFilter, ...data]
        state.speakerFilterMeta = {
          pageCount,
          perPage,
          totalCount,
          currentPage,
       }
    },
    [GET_DATE_LIST_ERROR]:(state, payload) => {
        state.dateListError = payload
    },
    [GET_DATE_LIST_LOADING]: (state, payload)=>{
        state.dateListLoading = payload
    },
    [GET_DATE_LIST_EVENTS]: (state, payload)=>{
        state.dateListEvent = payload
    },
    [GET_GIVEAWAYS_ERROR]:(state,payload)=>{
        state.giveawaysError = payload
    },
    [GET_GIVEAWAYS_LOADING]:(state,payload)=>{
        state.giveawaysLoading = payload
    },
    [GET_GIVEAWAYS]:(state,payload)=>{
      state.giveaways = [...payload.data]
      state.pageCount.giveawaysCount = +payload.pageCount
    },
    [GET_PARTNER_FILES_ERROR]:(state,payload)=>{
      state.partnerFiles = payload
    },
    [GET_PARTNER_FILES_LOADING]:(state,payload)=>{
        state.partnerFilesLoading = payload
    },
    [GET_PARTNER_FILES]:(state,payload)=>{
        state.partnerFiles = [...payload.data]
        state.pageCount.partnerFiles = +payload.pageCount
    },
	[POST_SURVEY_CLASSIC_ERROR]: (state, payload) => {
		state.surveyPostError = payload
	},
	[POST_SURVEY_CLASSIC_LOADING]: (state, payload) => {
		state.surveyLoading = payload
	},
	[GET_SURVEY]: (state, payload) => {
		state.survey = payload
	},
	[GET_SURVEY_LOADING]: (state, payload) => {
		state.loading = payload
	},
	[GET_SURVEY_ERROR]: (state, payload) => {
		state.surveyError = payload
	},
    [GET_GIVEAWAYS_ERROR_CLEAR]:(state)=>{
        state.surveyError = null
    },
	[SESSION_EVENT_DELETE_LOADING]: (state, payload) => {
		state.deleteQuestionLoading = payload
	},
	[GET_SESSIONS_SPEAKERS_LIST]: (state, payload) => {
		state.sessionAllSpeakers = [...payload.data]
		state.pageCount.sessionsSpeakers = +payload.pageCount
	},
	[GET_SESSIONS_SPEAKERS_LIST_LOADING]: (state, status) => {
		state.sessionAllSpeakersLoading = status
	},
	[GET_SESSIONS_SPEAKERS_LIST_ERROR]: (state, error) => {
		state.sessionAllSpeakersError = error
	},
	[GET_SUB_SESSIONS]: (state, payload) => {
		state.subSessions = [...payload.data]

		state.pageCount.subSessions = +payload.pageCount
	},
	[GET_SUB_SESSIONS_LOADING]: (state, status) => {
		state.subSessionsLoading = status
	},
	[GET_SUB_SESSIONS_ERROR]: (state, error) => {
		state.subSessionsError = error
	},
	[EVENT_CLEAR_EXHIBITOR]: (state) => {
		state.exhibitor = null
	},
	[GET_BOOT_STAFF_LIST]: (state, payload) => {
		state.boothStaffList = [...payload.data]
		state.pageCount.boothStaff = +payload.pageCount
		state.totalCount.boothStaff = +payload.totalCount
	},
	[BOOT_STAFF_LOADING_STATUS]: (state, status) => {
		state.boothStaffLoading = status
	},

	[EVENT_LOADING_STATUS]: (state, status) => {
		state.loading = status
	},

	[EVENTS_FETCH]: (state, payload) => {
		state.event = initialState.post
		state.events = [...payload.data]
		state.pageCount.events = +payload.pageCount
	},

	[EVENTS_FETCH_CATEGORIES]: (state, payload) => {
		const { data, pageCount, perPage, totalCount, currentPage } = payload
		state.categories = [...state.categories, ...data]
		state.categoriesMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
	},

	[GET_ACTION_LINKS]: (state, payload) => {
		const { data, pageCount, perPage, totalCount, currentPage } = payload

		state.actionLinks = data
		state.actionLinksMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
	},

	[GET_ACTION_FILES]: (state, payload) => {
		const { data, pageCount, perPage, totalCount, currentPage } = payload

		state.actionFiles = data
		state.actionFilesMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
	},

	[EVENT_GET]: (state, payload) => {
		state.event = payload
	},
	[EVENT_PRIVATE_LOADING]: (state, payload) => {
		state.privateLoading = payload
	},

	[REMOVE_ATTENDEES_EVENT]: (state) => {
		state.attendees = []
	},

	[AGENDA_EVENT_GET]: (state, payload) => {
		state.agenda = [...payload.data]
		state.pageCount.agendas = +payload.pageCount
	},

	[SESSION_EVENT_GET]: (state, payload) => {
		state.session = payload
	},

	[SESSION_EVENT_CLEAR]: (state) => {
		state.session = null
	},

	[ATTENDEES_EVENT_GET]: (state, payload) => {
		state.attendees = [...payload.data]
		state.pageCount.attendees = +payload.pageCount
		state.totalCount.attendees = +payload.totalCount
	},

	[ATTENDEES_EVENT_CLEAR]: (state) => {
		state.attendees = []
	},

	[ATTENDEE_EVENT_GET]: (state, payload) => {
		state.attendee = payload
	},

	[PARTNERS_EVENT_GET]: (state, payload) => {
		state.partners = [...payload.data]
		state.pageCount.partners = +payload.pageCount
	},

	[EVENT_GET_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[SESSION_EVENT_QUESTIONS_GET]: (state, payload) => {
		const { data, pageCount, perPage, totalCount, currentPage } = payload
		state.sessionQuestions = data
		state.sessionQuestionsMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
	},

	[SESSION_EVENT_QUESTIONS_CLEAR]: (state) => {
		state.sessionQuestions = null
		state.sessionQuestionsMeta = null
	},

	[EVENTS_CLEAR]: (state) => {
		state.categories = []
		state.categoriesMeta = null
	},

	[EVENT_LOADING_CATEGORIES_STATUS]: (state, payload) => {
		state.loadingCategories = payload
	},

	[EVENT_GET_TRACKS]: (state, payload) => {
		const { data, pageCount, perPage, totalCount, currentPage } = payload
		state.tracks = [...state.tracks, ...data]
		state.tracksMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
	},

	[EVENT_CLEAR_TRACKS]: (state) => {
		state.tracks = []
		state.tracksMeta = null
	},

	[EVENT_TRACKS_LOADING_STATUS]: (state, value) => {
		state.loadingTracks = value
	},

	[EVENT_MY_AGENDA_LOADING_STATUS]: (state, payload) => {
		state.myAgendaIsLoading = payload.value
		state.myAgendaIdIsLoading = payload.id || null
	},

	[EVENT_AGENDA_UPDATE_ITEM]: (state, { agenda, id, remove, filter }) => {
		if (remove) {
			if (filter === 'scheduled') {
				state.agenda = removeAgendaItem(state, id)
			} else {
				state.agenda = agenda.is_registered
					? updateAgendaItem(state, id, agenda)
					: removeAgendaItem(state, id)
			}
		} else {
			state.agenda = updateAgendaItem(state, id, agenda)
		}
	},

	[EVENT_POLLS_LOADING_STATUS]: (state, status) => {
		state.pollsLoading = status
	},

	[UPDATE_EVENT_POLLS]: (state, polls) => {
		state.event = { ...state.event, polls }
	},

	[EVENT_SPEAKERS_GET]: (state, payload) => {
		const { data, pageCount, perPage, totalCount, currentPage } = payload
		state.speakers = data
		state.speakersMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
	},

	[EVENT_SPEAKERS_CLEAR]: (state) => {
		;(state.speakers = []), (state.speakersMeta = null)
	},

	[EVENT_RATINGS_LOADING_STATUS]: (state, status) => {
		state.ratingsLoading = status
	},

	[UPDATE_EVENT_RATINGS]: (state, ratings) => {
		state.event = { ...state.event, ratings }
	},

	[UPDATE_SESSION_RATINGS]: (state, ratings) => {
		state.session = { ...state.session, ratings }
	},

	[EVENT_GET_EXHIBITOR]: (state, exhibitor) => {
		state.exhibitor = exhibitor
	},
	[EVENT_GET_EXHIBITOR_ERROR]: (state, payload) => {
		state.exhibitorError = payload
	},
	[SET_FOLLOW_STATUS]: (state, status) => {
		state.exhibitorPartner.follow_status = status
	},
	[SET_FOLLOW_NOTE]: (state, note) => {
		state.exhibitorPartner.follow_note = note
	},
	[DELETE_FOLLOW_NOTE]: (state, note) => {
		state.exhibitorPartner.follow_note = note
	},
	[EVENTS_FETCH_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},
	[POST_EVENT_SESSIONS_REGISTER_LOADING]: (state, payload) => {
		state.sessionRegisterLoading = payload
	},
	[POST_EVENT_SESSIONS_REGISTER]: (state, sessionRegister) => {
		state.sessionRegister = sessionRegister
	},
	[DELETE_EVENTS_SESSIONS_REGISTER]: (state, deleteSessionRegister) => {
		state.deleteSessionRegister = deleteSessionRegister
	},
}
